var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"k-flex-col"},[_c('TableAssos',{attrs:{"sit":_vm.sit,"project":_vm.project}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }